/*
  HIT AND HOPE search normalizer
  Makes joined-up searches work in predictive search and normal search.
  Examples:
  - ballmarker -> ball marker
  - golfsocks -> golf socks
  - oldbastards -> old bastards
*/
(() => {
  const aliasRules = [
    { pattern: /\bgolf\s*ball\s*markers?\b/gi, replacement: 'golf ball marker' },
    { pattern: /\bball\s*markers?\b/gi, replacement: 'ball marker' },

    { pattern: /\bgolf\s*socks?\b/gi, replacement: 'golf socks' },

    { pattern: /\bhit\s*(and|&)\s*hope\b/gi, replacement: 'hit and hope' },

    { pattern: /\bold\s*bastards?\b/gi, replacement: 'old bastards' },
    { pattern: /\bgirls?\s*power\b/gi, replacement: 'girls power' },

    { pattern: /\bgift\s*boxes?\b/gi, replacement: 'gift box' },
    { pattern: /\bsock\s*packs?\b/gi, replacement: 'sock pack' },

    { pattern: /\bdark\s*blue\b/gi, replacement: 'dark blue' },
    { pattern: /\bnavy\s*blue\b/gi, replacement: 'navy blue' },
    { pattern: /\bice\s*blue\b/gi, replacement: 'ice blue' }
  ];

  const normalize = (value) => {
    let normalized = String(value || '').trim();

    aliasRules.forEach((rule) => {
      normalized = normalized.replace(rule.pattern, rule.replacement);
    });

    return normalized.replace(/\s+/g, ' ').trim();
  };

  const isSearchInput = (input) => {
    return (
      input &&
      input.matches &&
      input.matches('input[type="search"][name="q"], input[name="q"]')
    );
  };

  const normalizeInputValue = (input) => {
    if (!isSearchInput(input)) return;

    const original = input.value;
    const normalized = normalize(original);

    if (
      normalized &&
      normalized.toLowerCase() !== String(original || '').trim().toLowerCase()
    ) {
      input.value = normalized;

      try {
        input.setSelectionRange(input.value.length, input.value.length);
      } catch (error) {
        // No-op.
      }
    }
  };

  const normalizeSearchForm = (form) => {
    if (!form || !form.matches('form[action*="/search"], form[role="search"]')) return;

    const input = form.querySelector('input[type="search"][name="q"], input[name="q"]');
    normalizeInputValue(input);
  };

  const redirectSearchPageIfNeeded = () => {
    try {
      const url = new URL(window.location.href);

      if (!url.pathname.includes('/search')) return;
      if (url.searchParams.get('hh_normalized') === '1') return;

      const originalQuery = url.searchParams.get('q');
      if (!originalQuery) return;

      const normalizedQuery = normalize(originalQuery);

      if (
        normalizedQuery &&
        normalizedQuery.toLowerCase() !== originalQuery.trim().toLowerCase()
      ) {
        url.searchParams.set('q', normalizedQuery);
        url.searchParams.set('hh_normalized', '1');
        window.location.replace(url.toString());
      }
    } catch (error) {
      // No-op.
    }
  };

  window.HHSearchNormalizer = {
    normalize,
    normalizeInputValue
  };

  /*
    Capture phase: this runs before Dawn predictive-search input handlers.
    So predictive search receives "ball marker", not "ballmarker".
  */
  document.addEventListener(
    'input',
    (event) => {
      normalizeInputValue(event.target);
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      normalizeSearchForm(event.target);
    },
    true
  );

  redirectSearchPageIfNeeded();
})();